<template>
  <v-container
    fill-height
    fluid
  >
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-tbody"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-flex
      v-if="!$apollo.loading"
    >
      <v-card>
        <v-row 
          v-if="!_.isEmpty(affReferrals)" 
          class="dates-toolbar"
          align="end"
          justify="end"
        >
          <v-col
            cols="4"
            sm="4"
            md="2"
            style="margin-top:20px;"
          >
            <v-menu
              v-model="PickerFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fromDate"
                  :label="$t('globals.from')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker 
                v-model="params.fromDate" 
                :locale="$i18n.locale"
                min="2017-05-01"
                :max="params.toDate || $moment().format('YYYY-MM-DD')"
                @input="PickerFrom = false"
                @change="reload(params.fromDate, 'fromDate')"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="4"
            sm="4"
            md="2"
          >
            <v-menu
              v-model="PickerTo"
              :close-on-content-click="false"
              :nudge-right="40"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="toDate"
                  :label="$t('globals.to')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker 
                v-model="params.toDate" 
                :locale="$i18n.locale"
                :min="params.fromDate || '2017-05-01'"
                :max="$moment().format('YYYY-MM-DD')"
                @input="PickerTo = false"
                @change="reload(params.toDate, 'toDate')"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            col-xs-12
          >
            <v-data-table  
              class="text-no-wrap" 
              :locale="$i18n.locale"
              :items="affReferrals.data"
              :items-per-page="affReferrals.per_page"
              :page="affReferrals.current_page"
              :server-items-length="affReferrals.total"
              :hide-default-footer="_.isEmpty(affReferrals.data)"
              :headers="headers"
              @update:items-per-page="reload($event, 'count')"
              @update:page="reload($event, 'page')"
            >
              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | moment('L') }}
              </template> 
              <template v-slot:item.name="{ item }">
                <b>{{ item.name }}</b><br>
              </template> 
              <template v-slot:item.email="{ item }">
                <small>{{ item.email }}</small>
              </template> 
              <template v-slot:item.trading_balance="{ item }">
                <b
                  v-for="(b, i) in item.trading_balance"
                  :key="i"
                >
                  {{ b.base_currency | renderSymbol }} {{ b.balance }}<br>
                </b>
              </template> 
              <template v-slot:item.pack="{ item }">
                <small>{{ item.pack != null ? item.pack : '-' }}</small>
              </template> 
              <template v-slot:item.count_connections="{ item }">
                {{ item.count_connections }}
              </template> 
            </v-data-table>
          </v-col>  
        </v-row>
        <v-row
          v-if="!$apollo.loading && _.isEmpty(affReferrals)"
          class="not-found"
          justify="center"
          align="center"
          py-10
        >
          <v-col>
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('aff.notFound') }}</p>
          </v-col>  
        </v-row>
      </v-card>  
    </v-flex>
  </v-container>
</template>

<script>

const AFF_REFERRALS_QUERY = require('@/graphql/queries/AffReferrals.gql');


export default {
  name: 'ReferralsTable',
  data() {
    return {
      loading: false,
      PickerFrom: null,
      PickerTo: null,
      params: {
        fromDate: this.$moment().subtract(180, 'days').format('YYYY-MM-DD HH:mm:ss'),
        toDate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        page: 1,
        count: 25
      },
      headers: [
        {
          sortable: false,
          text: this.$t('aff.regAt'),
          value: 'created_at'
        },
        {
          sortable: false,
          text: this.$t('aff.investor'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('globals.email'),
          value: 'email'
        },
        {
          sortable: false,
          text: this.$t('aff.pack'),
          value: 'pack'
        },
        {
          sortable: false,
          text: this.$t('aff.tradersBots'),
          value: 'count_connections'
        },
        {
          sortable: false,
          text: this.$t('aff.aum'),
          value: 'trading_balance'
        },
      ]
    }
    
  },
  computed: {
    fromDate() {
      return this.$moment(this.params.fromDate).format('ll');
    },
    toDate() {
      return this.$moment(this.params.toDate).format('ll');
    }
  },
  methods: {
   reload(value, from) {
      this.params[from] = value
      this.params.fromDate = this.$moment(this.params.fromDate).format('YYYY-MM-DD HH:mm:ss')
      this.params.toDate = this.$moment(this.params.toDate).format('YYYY-MM-DD HH:mm:ss')
      this.$apollo.queries.affReferrals.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    affReferrals: {
      query: AFF_REFERRALS_QUERY,
      variables() {
        return this.params
      }
    }
  }
}
</script>

<style lang="scss">


</style>
